import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import FuneralServicesSelector from './FuneralServicesSelector';

const FuneralServiceSelectorModal = (props) => {
  return (
    <Modal show={props.show} onHide={props.onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Ricerca Servizio
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FuneralServicesSelector onChange={props.onChange} />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Chiudi</Button>
      </Modal.Footer>
    </Modal>
  );
};

FuneralServiceSelectorModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.function,
  onChange: PropTypes.function,
};

export default FuneralServiceSelectorModal;
